import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import TabsComponent from '../tabs-new';
import { NAV_HEIGHT } from './constants';

export const Tabs = styled(TabsComponent)<{ mobileSearchBarVisible: boolean }>(
  p => css`
    position: sticky;
    top: ${layout.headerHeight.desktop.rem};
    background: ${p.theme.bg.primary};
    z-index: 99;
    height: ${`${NAV_HEIGHT}px`};

    ${media.mediumUp`
      margin: 0 ${layout.spacing.xSmall};
    `}

    ${media.smallOnly`
    top: ${
      p.mobileSearchBarVisible
        ? layout.headerHeight.mobileWithSearch.rem
        : layout.headerHeight.mobile.rem
    };
  `};
  `
);
